export const checkWin = (picking, getCell, coords, grid, gridSize) => {
    let directions = [
        // orthogonal
        [0, 0, 1],
        [0, 1, 0],
        [1, 0, 0],

        // diagonal
        [0, 1, 1],
        [0, -1, 1],
        [1, 0, 1],
        [1, 0, -1],
        [1, 1, 0],
        [1, -1, 0],

        // double diagonal
        [1, 1, 1],
        [-1, 1, 1],
        [1, -1, 1],
        [1, 1, -1]
    ]


    const outOfBounds = (ary) => {
        for (let i = 0; i < ary.length; i++) {
            if (ary[i] >= gridSize || ary[i] < 0) return true;
        }
        return false;
    }

    const check = (transformasjonsmatrise) => {
        let curCoords = [...coords];
        let done = false
        // start at one end of the line
        while (!done) {
            let ary = arSub(curCoords, transformasjonsmatrise)
            if (outOfBounds(ary)) {
                done = true;
            } else {
                curCoords = ary;
            }
        }
        done = false;
        let matches = []
        // work our way to the other end
        while (!done) {
            const owner = getCell(curCoords).owner;
            if (owner === picking) {
                matches.push(curCoords);
            } else {
                return;
            }
            let ary = arAdd(curCoords, transformasjonsmatrise);
            if (outOfBounds(ary))
                done = true;
            else
                curCoords = ary;
        }

        if (matches.length >= gridSize)
            return matches;
    }

    for (let i = 0; i < directions.length; i++) {
        const winnerRow = check(directions[i]);
        if (!winnerRow) continue;
        return winnerRow;
    }
    return false;
}

const arSub = (arr, mutator) => {
    let ary = [...arr];
    for (let i = 0; i < arr.length; i++) {
        ary[i] = ary[i] - mutator[i]
    }
    return ary;
}

const arAdd = (arr, mutator) => {
    let ary = [...arr];
    for (let i = 0; i < arr.length; i++) {
        ary[i] = ary[i] + mutator[i]
    }
    return ary;
}
